import { Box, Button, Flex, Heading, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { UniformGalleryFilters } from '../../types';
import { SelectField } from '@/components/SelectField';
import { Club, UniformSeason } from '@/model';
import { useTranslation } from 'react-i18next';
import TeamFilterSelect from '@/components/TeamFilterSelect';

export interface UniformGalleryFilterBoxProps {
  filtersForm: UseFormReturn<UniformGalleryFilters>;
  seasons: UniformSeason[] | undefined;
  clubs: Club[];
  forceRefetch: () => void;
}

export const UniformGalleryFilterBox = ({ filtersForm, seasons, clubs }: UniformGalleryFilterBoxProps) => {
  const { t } = useTranslation();
  const { register, reset } = filtersForm;

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>
          {t('pages.application_uniform_gallery.components.uniform_gallery_filter_box.uniform_gallery_filter_title')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'row' }} gap='small' rowGap='micro'>
        <SimpleGrid
          gap='deka'
          alignItems='flex-end'
          columns={{ base: 1, sm: 2, md: 4, lg: 5, xl: 6 }}
          rowGap='xxsmall'
          flexGrow={1}
        >
          <TeamFilterSelect showFlag name='team_uuid' control={filtersForm.control} clubs={clubs} width='100%' />

          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>
              {t('pages.application_uniform_gallery.components.uniform_gallery_filter_box.uniform_gallery_filter_season_label')}
            </Text>
            <SelectField {...register('season_uuid')}>
              <option value=''>
                {t(
                  'pages.application_uniform_gallery.components.uniform_gallery_filter_box.uniform_gallery_filter_season_default_option',
                )}
              </option>
              {seasons?.map(item => (
                <option key={item.uuid} value={item.uuid}>
                  {item.title}
                </option>
              ))}
            </SelectField>
          </InputGroup>
        </SimpleGrid>
        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.application_uniform_gallery.components.uniform_gallery_filter_box.uniform_gallery_filter_clear_button')}
        </Button>
      </Flex>
    </Box>
  );
};
